import { render, staticRenderFns } from "./messageSetting.vue?vue&type=template&id=f60f4fae&scoped=true"
import script from "./messageSetting.vue?vue&type=script&lang=js"
export * from "./messageSetting.vue?vue&type=script&lang=js"
import style0 from "./messageSetting.vue?vue&type=style&index=0&id=f60f4fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60f4fae",
  null
  
)

export default component.exports